import { inject } from '@angular/core';
import {
  HttpRequest,
  HttpInterceptorFn,
  HttpHandlerFn,
} from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { SHARED_CONFIG } from '../util-config/token/shared-config.token';
import { SpinnerMode } from '../enums/spinner-mode.enum';
import { SettingsStore } from '../+state/settings.store';
import { SpinnerService } from '../services/spinner.service';

export const SpinnerInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const spinnerService = inject(SpinnerService);
  const settingsStore = inject(SettingsStore);
  const config = inject(SHARED_CONFIG);
  const spinnerMode = req.headers.get('X-spinner-mode');

  if (
    (spinnerMode && spinnerMode === SpinnerMode.OFF) ||
    !req.url.includes(config.apiUrl)
  ) {
    return next(req);
  }

  spinnerService.showSpinner(spinnerMode as SpinnerMode);
  settingsStore.updateLoading(true);

  return next(req).pipe(
    finalize(() => {
      spinnerService.hideSpinner();
      settingsStore.updateLoading(false);
    }),
  );
};
